import React, {Fragment} from 'react';
import { Outlet } from 'react-router-dom';
import { ReactComponent as ArrowLeft } from '../Assets/ArrowLeft.svg';
import { ReactComponent as ArrowRight } from '../Assets/ArrowRight.svg';


const ProjectComponent = () => {
  return (
    <Fragment>
         <div className="md:min-h-screen lg:mb-0 lg:mt-0 mt-16 mb-24 lg:mt-0 text-white px-3 flex items-center mx-auto py-16 px-4 sm:py-24 sm:px-6 sm:max-w-7xl lg:px-8">
          <div className=''>
              <div className="flex items-center mb-2 gap-2">
                   <h2 className="flex items-center text-yellow-400 font-semibold text-lg sm:text-2xl"><ArrowLeft/>02<ArrowRight/></h2>
                    <span className=" block text-md sm:text-base font-medium text-zinc-400">
                           Yeah, I work hard 💼
                    </span>
                  <h2 className="flex items-center text-yellow-400 font-semibold text-lg sm:text-2xl"><ArrowLeft/>/02<ArrowRight/></h2>
              </div>
              <Outlet />
          </div>
        </div>
    </Fragment>
  )
}

export default ProjectComponent